<template>
  <div class="details">
    <Headers></Headers>
    <div class="center">
      <img
        class="center-img"
        src="https://aliyunosszs.musicwow.com/APPimg/league/bg.png"
      />
      <div class="center-list">
        <h3>{{ detailsTitle }}</h3>
        <div class="list-show"></div>
        <div class="list-body" v-html="newsList">
          <!-- {{newsList}} -->
        </div>
      </div>
    </div>
    <Footer></Footer>
  </div>
</template>

<script>
import Headers from "@/components/header.vue";
import Footer from "@/components/footer.vue";

export default {
  name: "details",
  data() {
    return {
      detailsTitle: "",
      newsList: [],
      type: 9,
    };
  },
  computed: {},
  components: {
    Headers,
    Footer,
  },
  methods: {},
  mounted() {
    this.type = 9;
  },
  async created() {
    let id =
      this.$route.query.id || this.$route.params.id || localStorage.detailsId;

    // console.log(id)
    this.$ajax
      .get("https://site.musicwow.com/api/v1/news/details/" + id)
      .then((res) => {
        let newsData = res.data.data;
        this.detailsTitle = newsData.title;
        this.newsList = newsData.content;
      })
      .catch((res) => {
        // console.log(res);
      });
  },
};
</script>
<style lang="sass" scoped>
.details
  width: 100%
  .center
    padding-top: 50px
    .center-list
      margin: 20px
      text-align: left
      .list-show
        width: 44px
        height: 5px
        background: #07D1AA
        margin: 20px 0
      .list-body
        color: rgba(0,0,0,0.5)
        img
          width: 100% !important
          height: 90% !important
    h3
      font-size: 24px
      max-width: 290px
      font-size: 20px
</style>

